let _ = t => t,
  _t;
import { gql } from "@edreamsodigeo/frontend-api-client";
export const GENERATE_TRIP_TOKEN = gql(_t || (_t = _`
  mutation generateTripToken($email: String!, $bookingId: Long!) {
    generateTripToken(email: $email, bookingId: $bookingId) {
      email
      bookingId
      token
    }
  }
`));